<script lang="typescript">
  // utils
  import apstate from '../utils/apstate';
  import { bin } from '../utils/chunk';

  // types
  import type { Readable } from 'svelte/store';
  import type { PresidentRaceFeed } from '../interfaces';

  // props
  export let feed: Readable<PresidentRaceFeed>;

  $: states = $feed.states.map((state) => {
    const name = apstate.get(state.code)!.ap;
    const stateFullName = state.name;
    const slug = apstate.get(state.code)!.slug;
    const precinctsReportingPct = state.precincts_reporting_percent.toFixed(1);
    const results = state.candidates;
    const eevp = state.eevp.toFixed(1);

    let candidate = '-';
    let party;
    let partyInitial;
    let isWinner = false;
    let isRunoff;

    const winner = results.find((candidate) => candidate.is_winner);

    if (state.total_votes > 0 || winner) {
      const leadingCandidate = winner || results[0];

      candidate = leadingCandidate.family_name;
      party = leadingCandidate.party;
      partyInitial = `(${
        party === 'gop' ? 'R' : party.slice(0, 1).toUpperCase()
      })`;
      isWinner = leadingCandidate.is_winner;
      isRunoff = leadingCandidate.is_runoff;
    }

    return {
      name,
      stateFullName,
      slug,
      party,
      partyInitial,
      candidate,
      isWinner,
      precinctsReportingPct,
      eevp,
      isRunoff
    };
  });

  $: columns = bin(states, 4);
</script>

<div class="key-and-dropdown">
  <p class="key-description"><span><span class="check">✓</span> Winner</span></p>
</div>

<div class="scoreboard-container display-flex">
  {#each columns as column, idx (idx)}
    <table class="text-sans-serif">
      <thead class="text-2xs text-uppercase">
        <tr>
          <th
            scope="col"
            class="col-1 border-b border-solid border-color-bar-grey text-left px-n3 py-n2 w-1">
            State
          </th>
          <th
          scope="col"
          class="col-2 border-b border-solid border-color-bar-grey text-left px-n3 py-n2 w-full">
          </th>
          <th
            scope="col"
            class="col-3 border-b border-solid border-color-bar-grey text-left px-n0 py-n2 w-full">
            Leader
          </th>
          <th
            scope="col"
            class="col-4 border-b border-solid border-color-bar-grey text-left px-n3 py-n2 w-1">
            % in
          </th>
        </tr>
      </thead>
      <tbody class="text-xs">
        {#each column as state (state.name)}
          <tr>
            <th
              scope="row"
              class="col-1 whitespace-no-wrap border-b border-solid border-color-bar-grey text-left px-n3 py-n2" aria-label="{state.stateFullName}">
              {state.name}
            </th>
            <td
            class="col-2 border-b border-solid border-color-bar-grey text-left px-n3 py-n2 { state.isWinner ? 'text-bold': 'text-medium' }"
            class:bg-dem-lightest={state.party === 'dem'}
            class:bg-gop-light={state.party === 'gop'}
            class:bg-other-light={state.party && (state.party!== 'dem') && (state.party !== 'gop')}
            >
            <span class="ml-n3">{#if state.isWinner}<span aria-label="checkmark, winner">✓</span>{/if}</span>
            </td>
            <td
              class="col-3 border-b border-solid border-color-bar-grey text-left px-n0 py-n2 { state.isWinner ? 'text-bold': 'text-medium' }"
              class:bg-dem-lightest={state.party === 'dem'}
              class:bg-gop-light={state.party === 'gop'}
              class:bg-other-light={state.party && (state.party!== 'dem') && (state.party !== 'gop')}>
              {state.candidate}{#if state.partyInitial}<span class="party-initial text-regular">&nbsp;{state.partyInitial}</span>{/if}
              {#if state.isRunoff}
              <span class="candidate__cell-runoff candidate__">Runoff</span>
              {/if}
            </td>
            <td
              class="col-4 whitespace-no-wrap border-b border-solid border-color-bar-grey text-right px-n3 py-n2">
              {state.eevp}<span class="candidate__pct-symbol">%</span>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/each}
</div>